import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";

const DetailSection = ({ projectType, location, area, status, description }) => {
  const facts = [
    { label: "Project type", value: projectType },
    { label: "Location", value: location },
    { label: "Built-up area", value: area },
    { label: "Status", value: status },
  ].filter((fact) => fact.value);

  return (
    <Box sx={{ px: { xs: 2, md: 7 }, py: { xs: 6, md: 9 } }}>
      <Box
        component={motion.div}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.35 }}
        transition={{ duration: 0.65, ease: "easeOut" }}
        sx={{ maxWidth: 1220, mx: "auto" }}
      >
        <Typography
          sx={{
            mb: 1.5,
            color: "#9a794b",
            fontSize: "0.68rem",
            fontWeight: 600,
            letterSpacing: "0.18em",
          }}
        >
          PROJECT STORY
        </Typography>
        <Typography
          component="h2"
          variant="h3"
          sx={{ mb: 4, fontSize: { xs: "2rem", md: "2.8rem" } }}
        >
          Designed around the way you live
        </Typography>

        {facts.length > 0 && (
          <Grid
            container
            sx={{
              mb: { xs: 4, md: 6 },
              borderTop: "1px solid #d9d5ca",
              borderBottom: "1px solid #d9d5ca",
            }}
          >
            {facts.map((fact, index) => (
              <Grid
                item
                xs={6}
                md={3}
                key={fact.label}
                sx={{
                  px: { xs: 1.5, md: 3 },
                  py: 2.5,
                  borderRight: {
                    xs: index % 2 === 0 ? "1px solid #d9d5ca" : "none",
                    md: index < facts.length - 1 ? "1px solid #d9d5ca" : "none",
                  },
                  borderBottom: {
                    xs: index < 2 ? "1px solid #d9d5ca" : "none",
                    md: "none",
                  },
                }}
              >
                <Typography
                  sx={{
                    mb: 0.8,
                    color: "#8f7248",
                    fontSize: "0.64rem",
                    fontWeight: 600,
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                  }}
                >
                  {fact.label}
                </Typography>
                <Typography
                  sx={{
                    color: "#292720",
                    fontFamily: 'Georgia, "Times New Roman", serif',
                    fontSize: { xs: "1rem", md: "1.2rem" },
                  }}
                >
                  {fact.value}
                </Typography>
              </Grid>
            ))}
          </Grid>
        )}

        {description && (
          <Typography
            sx={{
              maxWidth: 850,
              color: "text.secondary",
              fontSize: { xs: "0.95rem", md: "1.05rem" },
              lineHeight: 1.9,
              whiteSpace: "pre-line",
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default DetailSection;
